import { BALANCE } from '../config/balance';
import type { PlayerStats } from '../core/types';
import { spawnBolt } from './bolts';
import { nearestEnemy } from './target';
import { Cooldown, type WeaponController } from './weapon-controller';
import type { Engine } from './engine';

interface StaffParams {
  count: number;
  damage: number;
  cd: number;
  boltSpeed: number;
  size: number;
}

/** 法杖：自动索敌弹，轻微追踪；进化奥术风暴。 */
export class StaffController implements WeaponController {
  readonly id = 'staff';
  owned = false;
  private level = 0;
  private isEvolved = false;
  private cooldown = new Cooldown();

  syncBuild(level: number, evolved: boolean): void {
    this.level = level;
    this.owned = level > 0;
    this.isEvolved = evolved;
    if (!this.owned) this.cooldown.reset();
  }

  private compute(stats: PlayerStats): StaffParams {
    const w = BALANCE.weapons.staff;
    const L = this.level;
    let count = 1 + w.addCount.filter((lv) => L >= lv).length;
    const damage = w.dmg * (1 + w.dmgPer * (L - 1));
    const cd = (w.cd * (1 - w.cdPer * (L - 1))) / stats.attackSpeedMul;
    let boltSpeed =
      w.boltSpeed * (1 + w.speedPer * (L - 1)) * stats.projectileSpeedMul;
    let size = w.size * (1 + w.sizePer * (L - 1)) * stats.areaMul;
    if (this.isEvolved) {
      const e = BALANCE.evolutions.arcane_storm;
      count += e.countBonus;
      size *= 1 + e.sizeBonus;
      boltSpeed *= 1 + e.speedBonus;
    }
    return { count, damage, cd, boltSpeed, size };
  }

  update(engine: Engine, dt: number): void {
    if (!this.owned) return;
    const p = this.compute(engine.player.stats);
    if (!this.cooldown.tick(dt, p.cd)) return;

    const player = engine.player;
    const target = nearestEnemy(engine.enemyPool.all(), player.x, player.y);
    const baseAngle = target
      ? Math.atan2(target.y - player.y, target.x - player.x)
      : Math.atan2(engine.faceY, engine.faceX);
    const w = BALANCE.weapons.staff;
    engine.fx.muzzle(player.x, player.y);

    for (let i = 0; i < p.count; i++) {
      const offset = (i - (p.count - 1) / 2) * 0.18;
      spawnBolt(engine.boltPool, {
        kind: 'staff',
        x: player.x, y: player.y,
        angle: baseAngle + offset,
        speed: p.boltSpeed,
        damage: p.damage, size: p.size,
        pierce: w.pierce, homing: w.homing,
        targetId: target ? target.id : -1,
      });
    }
  }
}
